import camelcaseKeys from 'camelcase-keys'

export class PageObjectAgenda {
  constructor (params = {}) {
    const { id, activityCategory, availableHours, location, title } = camelcaseKeys(params ? params : {})
    this.id = id
    this.title = title || null
    this.activityCategory = activityCategory || null
    this.availableHours = availableHours || []
    this.location = location || false
  }
}
